export default "__VITE_ASSET__ca40xMOg__"